export default __webpack_public_path__ + "790affb0b88c01179d759b2daa120ffa.png";